async function refreshThemeCartDrawer() {
  const drawer = document.querySelector("#sidebar-cart");
  if (!drawer) return;

  const res = await fetch(
    window.routes.cartUrl + "?view=drawer&timestamp=" + Date.now(),
    {
      credentials: "same-origin",
      method: "GET",
    },
  );
  const html = await res.text();

  const temp = document.createElement("div");
  temp.innerHTML = html;

  const newCart = temp.querySelector(".Cart");
  const currentCart = drawer.querySelector(".Cart");
  if (newCart && currentCart) {
    currentCart.parentNode.replaceChild(newCart, currentCart);
  }

  const settings = temp.querySelector('[data-section-type="cart-template"]');
  if (settings) {
    const data = JSON.parse(settings.getAttribute("data-section-settings"));
    const countEl = document.querySelector(".header_cart_count");
    if (countEl) countEl.innerHTML = data.itemCount;
  }
}

function openCartDrawer() {
  const drawer = document.querySelector("#sidebar-cart");
  if (drawer && !drawer.classList.contains("show")) {
    drawer.classList.add("show");
    document.querySelector("body").classList.add("show_overlay");
  }
}

// When a product is added via a Rebuy widget: refresh the drawer, open it,
// then reinit Rebuy so widgets inside the drawer get fresh recommendations.
document.addEventListener("rebuy.add", () => {
  refreshThemeCartDrawer().then(() => {
    openCartDrawer();
    if (typeof Rebuy !== "undefined" && typeof Rebuy.reinit === "function") {
      Rebuy.reinit();
    }
  });
});

function getCustomerTags() {
  const el = document.querySelector("script[data-customer-tags]");
  if (!el) return [];
  try {
    return JSON.parse(el.innerHTML);
  } catch (e) {
    console.error("Error parsing customer tags JSON", e);
    return [];
  }
}

function getThemeSettings() {
  const el = document.querySelector("script[data-rebuy-progress-bar-settings]");
  if (!el) return {};
  try {
    return JSON.parse(el.innerHTML);
  } catch (e) {
    console.error("Error parsing theme settings JSON", e);
    return {};
  }
}

function updateRebuyProgressBarSettings() {
  const customerTags = getCustomerTags();
  const themeSettings = getThemeSettings();

  if (
    customerTags.length === 0 ||
    Object.keys(themeSettings).length === 0 ||
    !window.Rebuy.SmartCart
  ) {
    return;
  }

  const huntClubTags = [
    "VIP Bronze Wing",
    "VIP Silver Decoy",
    "VIP Gold Sprig",
    "VIP Platinum Drake",
  ];
  const isHuntClub = huntClubTags.some((tag) => customerTags.includes(tag));

  // If there is a Hunt Club threshold set and the customer has a Hunt Club tag, use the Hunt Club threshold.
  if (isHuntClub && themeSettings.rebuy_cart_hunt_club_threshold) {
    window.Rebuy.SmartCart.progressBar.tiers[0].minimum =
      themeSettings.rebuy_cart_hunt_club_threshold;
    return;
  }

  // Otherwise, use the free shipping threshold - if it exists. Falls back to whatever value is already set in Rebuy
  if (themeSettings.rebuy_cart_free_shipping_threshold) {
    window.Rebuy.SmartCart.progressBar.tiers[0].minimum =
      themeSettings.rebuy_cart_free_shipping_threshold;
  }
}

document.addEventListener("rebuy.init", updateRebuyProgressBarSettings);

// After any Rebuy cart change, remove Order Protect if it's the only item left.
document.addEventListener("rebuy:cart.change", function () {
  fetch(window.routes.cartUrl + ".js")
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      if (!cart || !cart.items) return;
      var visibleItems = cart.items.filter(function (item) {
        return item.product_type !== "Order Protect";
      }).length;
      var orderProtectItem = cart.items.find(function (item) {
        return item.product_type === "Order Protect";
      });
      if (visibleItems === 0 && orderProtectItem) {
        fetch(window.routes.cartChangeUrl + ".js", {
          body: JSON.stringify({ id: orderProtectItem.key, quantity: 0 }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });
      }
    });
});
